import { Component, input } from '@angular/core';
import { QuestionarioFormValue } from '../../core/models/questionario-form.model';

/**
 * Corpo do questionário (informações gerais, perguntas na ordem exibida e perfis associados),
 * sem nenhuma moldura própria.
 *
 * Existe para que os dois consumidores tenham exatamente o mesmo conteúdo sem duplicar markup:
 * o modal "Visualizar questionário", que o envolve em um diálogo, e o container de impressão
 * do `QuestionarioFormComponent`, que fica oculto na tela e só aparece no `@media print`.
 *
 * Os estilos continuam vindo do SCSS do modal (classes `visualizar-questionario-modal__*`),
 * que é global o suficiente para alcançar os dois usos.
 */
@Component({
  selector: 'app-questionario-conteudo',
  standalone: true,
  imports: [],
  templateUrl: './questionario-conteudo.component.html',
  styleUrl: './visualizar-questionario-modal.component.scss',
})
export class QuestionarioConteudoComponent {
  readonly questionario = input.required<QuestionarioFormValue>();
}
